const E0 = {
  id: "E0",
  key: "E0",
  name: "Không rõ",
  label: "Không rõ",
};
const E1 = {
  id: "E1",
  key: "E1",
  name: "Đối thủ",
  label: "Đối thủ",
};
const E2 = {
  id: "E2",
  key: "E2",
  name: "Đại lý",
  label: "Đại lý",
};
const E3 = {
  id: "E3",
  key: "E3",
  name: "CS",
  label: "CS",
};
const E4 = {
  id: "E4",
  key: "E4",
  name: "Hotline",
  label: "Hotline",
};
const E5 = {
  id: "E5",
  key: "E5",
  name: "Từ E1",
  label: "Từ E1",
};
const E6 = {
  id: "E6",
  key: "E6",
  name: "MLM",
  label: "MLM",
};
const E7 = {
  id: "E7",
  key: "E7",
  name: "KDS",
  label: "KDS",
};
const E8 = {
  id: "E8",
  key: "E8",
  name: "DnC",
  label: "DnC",
};
const E9 = {
  id: "E9",
  key: "E9",
  name: "Sales",
  label: "Sales",
};
const E10 = {
  id: "E10",
  key: "E10",
  name: "S&M",
  label: "S&M",
};

const sources = [E0, E1, E2, E3, E4, E5, E6, E7, E8, E9, E10];

const findSource = (id) => sources.find((s) => s.id === id);

export { E0, E1, E2, E3, E4, E5, E6, E7, E8, E9, E10, sources, findSource };
